/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Component, Prop, Vue} from 'vue-property-decorator';
import {
    PcPlatformInterface,
    PsPlatformInterface,
    XboxPlatformInterface,
} from '@/store/modules/issues/types';
import {GamePlatformInterface} from '@/store/modules/games/types';
import {Getter} from 'vuex-class';

@Component({
    name: 'c-details-list',
})
export default class DetailsList extends Vue {
    @Getter('getPlatforms', {namespace: 'gamesStateModule'}) public getPlatforms!: GamePlatformInterface[];
    public platformType: string = '';
    @Prop(Object) private content!: PcPlatformInterface | PsPlatformInterface | XboxPlatformInterface;

    /**
     * Mounted lifecycle hook
     */
    public mounted(): void {
        // todo find better way to show the correct platform type
        if (undefined !== this.content.hasOwnProperty('platformType')) {
            for (const platform of this.getPlatforms) {
                for (const type of platform.types) {
                    if (type.prefix === (this.content as XboxPlatformInterface | PsPlatformInterface).platformType) {
                        this.platformType = type.name;
                    }
                }
            }
        }

    }
}
